import React from 'react'
import { Route, Switch } from 'react-router'
import ReportVehicleResults from './ReportVehicleResults'

const Components = props => (
    <Switch>
        <Route exact path={`${props.match.url}/:year?`} component={ReportVehicleResults} />
    </Switch>
)

export default Components
